import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ProjectLog from './ProjectLog';
import './ProjectLogModal.css';

const ProjectLogModal = ({ open, onClose, projectId, projectName }) => {
  const handleOpenInNewTab = () => {
    window.open(`/project/logs/${projectId}`, '_blank');
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="project-log-modal"
      aria-describedby="project-log-in-modal"
    >
      <Box className="project-log-modal-box">
        <AppBar position="static" elevation={0} className="project-log-modal-appbar">
          <Toolbar className="project-log-modal-toolbar">
            <div style={{ flexGrow: 1 }} />
            <IconButton color="inherit" onClick={handleOpenInNewTab} aria-label="open in new tab">
              <OpenInNewIcon />
            </IconButton>
            <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className="project-log-modal-content modal-content-style">
          <ProjectLog
            params={{ id: projectId }}
            location={{
              state: { project_name: projectName },
              pathname: `/project/logs/${projectId}`,
            }}
            navigate={() => {}}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default ProjectLogModal;
